var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('ht-view',{ref:"htView",staticClass:"ht-view",attrs:{"type":"3d","auto-invalidate":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }